import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Small shared hook that returns the current user's soul profile
 * (from /api/soul/me). Cached in-memory so multiple mounts don't refetch.
 */
let cached = null;
let pending = null;

export function useSoulProfile() {
  const [profile, setProfile] = useState(cached);
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    if (cached) return;
    if (!pending) {
      pending = api
        .get("/soul/me")
        .then((r) => {
          cached = r.data;
          return r.data;
        })
        .catch(() => {
          cached = null;
          return null;
        })
        .finally(() => {
          pending = null;
        });
    }
    pending.then((data) => {
      setProfile(data);
      setLoading(false);
    });
  }, []);

  const dominant = profile?.profile?.elemental?.dominant || "Fire";
  const chosen = profile?.profile?.chosen_house || null;
  return { profile, loading, element: chosen || dominant, dominant, chosen };
}

export function clearSoulProfileCache() {
  cached = null;
}

/** Update the in-memory cache after committing a House (POST /soul/house). */
export function setCachedHouse(house) {
  if (cached?.profile) {
    cached = { ...cached, profile: { ...cached.profile, chosen_house: house } };
  }
}
